module.exports = __webpack_public_path__ + "static/media/img.a0d33ed3.png";